var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.337,
    height: 20.222,
    viewBox: "0 0 20.337 20.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C_-_60_x2C__career_x2C__Advancement_x2C__employee_x2C__ladder_x2C__promotion_x2C__staff_x2C__work",
    transform: "translate(-45.155 -46.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12059",
    "data-name": "Group 12059",
    transform: "translate(45.155 46.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M51.01,394.58H46.66a1.5,1.5,0,0,0-1.505,1.5v1.93H52.5V396.06A1.486,1.486,0,0,0,51.01,394.58Zm-1.751,2.791h-.865v-.861h.865Zm0-1.292h-.865v-.861h.865Z",
    transform: "translate(-45.155 -377.785)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M179.862,288.823v1.93h7.344v-1.947a1.486,1.486,0,0,0-1.488-1.48h-4.35A1.5,1.5,0,0,0,179.862,288.823Zm3.239-.86h.865v.861H183.1Zm0,1.292h.865v.861H183.1Z",
    transform: "translate(-173.365 -275.704)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M352.768,50.184a1.921,1.921,0,1,0-1.931-1.921A1.928,1.928,0,0,0,352.768,50.184Z",
    transform: "translate(-336.095 -46.342)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M83.356,278.736a1.921,1.921,0,1,0,1.931,1.921A1.928,1.928,0,0,0,83.356,278.736Z",
    transform: "translate(-79.676 -267.528)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M216.132,173.395a1.931,1.931,0,1,0,1.931-1.921A1.928,1.928,0,0,0,216.132,173.395Z",
    transform: "translate(-207.886 -165.439)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M320.422,162.186h-4.35a1.5,1.5,0,0,0-1.505,1.5v1.93h7.344v-1.948A1.486,1.486,0,0,0,320.422,162.186Zm-1.751,2.791h-.865v-.861h.865Zm0-1.292h-.865v-.861h.865Z",
    transform: "translate(-301.573 -156.599)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M53.828,76.223l2.165,1.724h0l.011.008.005,0,.013.008.007,0,.014.007.007,0,.009,0h0l.025.007H56.1l.032,0h0l.032,0h.015l.025-.007h0l.009,0,.007,0,.014-.007.007,0,.013-.008.005,0,.011-.008h0l2.165-1.724a.226.226,0,1,0-.281-.354l-1.8,1.432V72.824h7.57a.226.226,0,1,0,0-.452h-7.8a.226.226,0,0,0-.226.226v4.7l-1.8-1.432a.226.226,0,0,0-.281.354Z",
    transform: "translate(-53.329 -71.117)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M252.663,324.418l-2.166-1.724-.007,0-.017-.011-.012-.007-.01,0-.017-.007-.014-.005-.011,0-.017,0-.015,0h-.044l-.013,0-.017,0-.012,0-.013,0-.017.007-.01,0-.012.007-.017.011-.007,0,0,0h0l-2.161,1.721a.226.226,0,1,0,.281.354l1.8-1.432v4.478h-7.57a.226.226,0,0,0,0,.452h7.8a.226.226,0,0,0,.226-.226v-4.7l1.8,1.432a.226.226,0,1,0,.281-.354Z",
    transform: "translate(-232.826 -309.32)",
    fill: "#37bdb0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffSchedule);
export default __webpack_public_path__ + "static/media/Staff_Schedule.d8de498973090cc7478f347230062fba.svg";
export { ForwardRef as ReactComponent };